import { Button } from "antd";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useSelector, useDispatch } from "react-redux";
import { setLoading } from "../../../redux/auth/actions";

const getPersistentSetting = () => {
  const setting = localStorage.getItem("html-text-editor-setting");
  if (setting === "1") return true;
  else return false;
};
const HTMLTextEditor = ({ quillattributes, update, defaultValue }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loading);
  const [ownValue, setOwnValue] = useState(defaultValue ?? "");

  const handleUpdate = () => {
    update(ownValue);
    dispatch(setLoading(false));
  };

  return (
    <div {...quillattributes}>
      <ReactQuill
        value={ownValue}
        onChange={(e) => {
          setOwnValue(e);
        }}
        className="h-[150px] relative"
      />

      <div className="flex relative justify-end border mt-2 border-[#fafafa] bg-[#fafafa]">
        <Button
          loading={loading}
          type="primary"
          className=" btn-primary"
          onClick={handleUpdate}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default HTMLTextEditor;
